






























import Vue from 'vue'
export default Vue.extend({
  computed: {
    toastState() {
      return this.$store.state.toast
    },
  },
})
